import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import CheckpointsRow from "./CheckpointsRow";
import CreateCheckpointModal from "./CreateCheckpointModal";
import { nanoid } from "nanoid";
import { Alert } from "react-bootstrap";
import ModalManager from "../../../../sub/modals/ModalManager";
function Checkpoints({
  materialTypeId,
  checkpoints,
  onSort,
  onUpdateCheckpoint,
  onDeleteCheckpoint,
}) {
  const [modal, setModal] = useState(null);

  const closeModal = () => setModal(null);

  const openEditModal = (checkpoint) => {
    if (!checkpoint) return;
    setModal(
      <CreateCheckpointModal
        materialTypeId={materialTypeId}
        checkpoint={checkpoint}
        onUpdateCheckpoint={(data) => onUpdateCheckpoint(data)}
        close={() => closeModal()}
      />,
    );
  };

  const openConfModal = (title, content, successCallback) => {
    setModal(
      <ModalManager
        showModal={true}
        title={title}
        content={content}
        successCallback={successCallback}
        closeModal={() => closeModal()}
        modalType="confirmation"
      />,
    );
  };

  const checkpointsNode =
    checkpoints &&
    checkpoints.map((checkpoint) => {
      return (
        <CheckpointsRow
          key={nanoid()}
          checkpoints={checkpoints}
          checkpoint={checkpoint}
          onSort={(checkpoint, direction) => onSort(checkpoint, direction)}
          onDeleteCheckpoint={(checkpoint) => onDeleteCheckpoint(checkpoint)}
          openEditModal={(checkpoint) => openEditModal(checkpoint)}
          openConfModal={(title, content, successCallback) =>
            openConfModal(title, content, successCallback)
          }
        />
      );
    });

  return (
    <>
      {checkpoints.length > 0 ? (
        <table className="table table-striped table-bordered col-12 tablee4coll">
          <thead>
            <tr>
              <th className="col-10">
                <FormattedMessage id="Checkpoint" />
              </th>
              <th className="col-2 text-center">
                <FormattedMessage id="Actions" />
              </th>
            </tr>
          </thead>

          <tbody>{checkpointsNode}</tbody>
        </table>
      ) : (
        <Alert variant="info" className="col-12">
          <FormattedMessage id="Empty.Checkpoint" />
        </Alert>
      )}

      {modal}
    </>
  );
}

export default Checkpoints;
